import { IoHelpCircleOutline } from "react-icons/io5";
import { Button, IconButton } from "@mui/material";
import { useState } from "react";

export function OverviewCard(props: { imageUrl: string }) {
  let [isOpen, setIsOpen] = useState(false);
  if (!props.imageUrl) {
    return null;
  }
  let button = (
    <IconButton aria-label="delete" size="small" id="help-button" onClick={() => setIsOpen((o) => !o)}>
      <IoHelpCircleOutline fontSize="30px" />
    </IconButton>
  );
  let modal = <></>;
  modal = (
    <img
      src={props.imageUrl}
      className={"overview-card" + (isOpen ? "" : " hidden")}
      onClick={() => setIsOpen(false)}
    ></img>
  );
  return (
    <>
      {button}
      {modal}
    </>
  );
}
